import { type ReactNode } from 'react';
import { Plus } from 'lucide-react';
import { Button } from '@/components/ui/Button';
import { Input } from '@/components/ui/Input';

interface CrudHeaderProps {
  title: string;
  description?: string;
  searchValue?: string;
  onSearchChange?: (value: string) => void;
  onCreate?: () => void;
  createLabel?: string;
  /** Extra buttons / filters rendered on the right (e.g. Bulk upload). */
  extraActions?: ReactNode;
}

export function CrudHeader({
  title,
  description,
  searchValue,
  onSearchChange,
  onCreate,
  createLabel = 'New',
  extraActions,
}: CrudHeaderProps) {
  return (
    <div className="mb-5 flex flex-col gap-3 sm:flex-row sm:items-end sm:justify-between">
      <div>
        <h1 className="text-2xl font-semibold text-brand-charcoal">{title}</h1>
        {description && <p className="mt-1 text-sm text-brand-gray-mid">{description}</p>}
      </div>
      <div className="flex flex-wrap items-center gap-2">
        {onSearchChange !== undefined && (
          <Input
            type="search"
            placeholder="Search…"
            value={searchValue ?? ''}
            onChange={(e) => onSearchChange(e.target.value)}
            className="w-48"
          />
        )}
        {extraActions}
        {onCreate && (
          <Button onClick={onCreate} size="md">
            <Plus className="h-4 w-4" aria-hidden />
            <span>{createLabel}</span>
          </Button>
        )}
      </div>
    </div>
  );
}
